<template>
  <div class="category-checkbox-list">
    <button
      class="category-list-btn p-1"
      :class="{ active }"
      @click="active = !active">
      表示選択
    </button>
    <div
      v-if="active"
      class="category-list_wrapper py-2">
      <b-form-group
        ref="categoryList"
        class="category-list mb-0">
        <b-form-checkbox
          :checked="isAllChecked"
          :indeterminate="indeterminate"
          @change="toggleAll">
          全て選択
        </b-form-checkbox>
        <div
          v-for="category in _categories"
          :key="category.id"
          class="category-list-item">
          <b-form-checkbox
            :checked="isSelected(category.id)"
            @change="toggleSelectCategories(category.id)">
            {{ category.name }}
          </b-form-checkbox>
          <pin-icon
            :is-pinned="isPinned(category.id)"
            @click.native="togglePin(category.id)" />
        </div>
      </b-form-group>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import PinIcon from '@/components/parts/PinIcon.vue'

export default {
  components: {
    PinIcon
  },
  data() {
    return {
      active: false,
    }
  },
  computed: {
    ...mapState('events', [
      'selectedCategories', 'categories', 'pinnedCategories'
    ]),
    _selectedCategories: {
      get() {
        return this.selectedCategories
      },
      set(v) {
        this.$store.commit('events/setSelectedCategories', v)
      }
    },
    isAllChecked() {
      return this._selectedCategories.length === this.categories.length
    },
    indeterminate() {
      return this._selectedCategories.length !== 0 && !this.isAllChecked
    },
    _pinnedCategories: {
      get() {
        return this.pinnedCategories
      },
      set(v) {
        this.$store.commit('events/setPinnedCategories', v)
      }
    },
    _categories() {
      const categories = [...this.categories].sort(
        (x, y) => {
          if (!this.isPinned(x.id) && this.isPinned(y.id)) {
            return 1
          }
          if (this.isPinned(x.id) && !this.isPinned(y.id)) {
            return -1
          }
          return 0
        }
      )
      return categories
    }
  },
  methods: {
    toggleAll() {
      this._selectedCategories = this.isAllChecked ? [] : [...this.categories.map(category => category.id)]
    },
    isSelected(categoryId) {
      return this._selectedCategories.includes(categoryId)
    },
    toggleSelectCategories(categoryId) {
      if (this.isSelected(categoryId)) {
        this._selectedCategories = this._selectedCategories.filter(category => category !== categoryId)
        return
      }
      this._selectedCategories = [...this.selectedCategories, categoryId]
    },
    isPinned(categoryId) {
      return this._pinnedCategories.includes(categoryId)
    },
    togglePin(categoryId) {
      if (this.isPinned(categoryId)) {
        this._pinnedCategories = this._pinnedCategories.filter(pinnedId => pinnedId !== categoryId)
      } else {
        this._pinnedCategories = [...this._pinnedCategories, categoryId]
      }
    },
  }

}
</script>

<style lang="scss" scoped>

.category-list-btn {
  border-radius: 4px;
  line-height: 1;
  padding: 16px;
  font-weight: bold;
  cursor: pointer;
  width: 64px;
  overflow: hidden;
  white-space: nowrap;

  background-color: $l-blue;
  box-shadow: 1px 2px 6px $grey05;
  border: none;
  font-size: 0.875rem;

  color: #fff;

  &.active {
    background-color: $blue;
  }
}

.category-list_wrapper {
  position: absolute;
  z-index: 1;
  background-color: #fff;
  border-radius: 4px;
  -webkit-box-shadow: 1px 2px 6px #838383;
  box-shadow: 1px 2px 6px #838383;
  width: 140px;
  padding: 4px 6px 4px 10px;
}

.category-list {
  max-width: 150px;
  max-height: 190px;
  padding: 5px 5px 5px 0;
  text-align: left;
  
  overflow-y: scroll;

  &-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 5px;
  }
}

</style>